module.exports = __webpack_public_path__ + "img/bank-account.b75bae78.png";